/* Solstice full-cart recovery v1. No identification or consent is inferred. */
(function (root) {
  'use strict';
  const propertyNames = new Set(['Composition', 'Emplacement', '_Configurateur', '_ConfigID', '_CompositionTitle', '_CompositionImage', '_CompositionMaterial', '_CompositionHash', '_CompositionVariant', '_Miniature', '_IsMaster','_solstice_preorder_v1','_solstice_preorder_source','_solstice_preorder_qty','_solstice_ready_qty']);
  function cleanItems(items) {
    if (!Array.isArray(items) || items.length > 100) throw Error('INVALID_CART');
    return items.map(i => {
      const id = Number(i.variant_id || i.id), quantity = Number(i.quantity);
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 100) throw Error('INVALID_ITEM');
      const properties = {};
      for (const [k, v] of Object.entries(i.properties || {})) if (propertyNames.has(k) && typeof v === 'string' && v.length <= 2048) properties[k] = v;
      return {id, quantity, properties};
    });
  }
  function snapshot(cart, locale, origin) {
    const items = cleanItems(cart.items || []);
    const payload = encodeURIComponent(JSON.stringify(items));
    const url = new URL('/cart', origin);
    url.searchParams.set('solstice_recovery', payload);
    url.searchParams.set('locale', locale);
    return { 'Source Name': 'web', 'Customer Locale': locale, cart_count: items.reduce((n,i) => n + i.quantity, 0), $currency: cart.currency,
      $value: Number(cart.total_price || 0) / 100, $extra: { checkout_url: url.toString(), line_items: (cart.items || []).map(i => ({
        title: i.product_title || i.title, variant_title: i.variant_title || '', quantity: i.quantity, variant_id: i.variant_id || i.id,
        line_price: Number(i.final_line_price ?? i.line_price ?? 0) / 100,
        product: {images: i.image ? [{src: i.image}] : [], variant: {images: i.featured_image?.url ? [{src: i.featured_image.url}] : []}}
      }))}};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {cleanItems, snapshot};
  if (!root?.document || !root.fetch) return;
  const script = root.document.currentScript, locale = script?.dataset.locale || 'fr';
  const nativeFetch = root.fetch.bind(root), route = root.Shopify?.routes?.root || '/';
  let timer, busy = false, last = '', recovering = false;
  const params = new URL(root.location.href).searchParams;
  async function restore() {
    if (!params.has('solstice_recovery') || root.location.pathname.replace(/\/$/, '') !== '/cart') return false;
    recovering = true;
    try {
      const raw = params.get('solstice_recovery');
      if (raw.length > 100000) throw Error('INVALID_CART');
      const items = cleanItems(JSON.parse(decodeURIComponent(raw)));
      if (!items.length) throw Error('EMPTY_CART');
      // Preserve the existing basket on validation errors. Shopify validates the
      // entire add request before clearing the old basket by key below.
      const before = await (await nativeFetch(route + 'cart.js')).json();
      const signature = i => JSON.stringify([i.variant_id || i.id, Object.entries(i.properties || {}).filter(([key])=>propertyNames.has(key)&&!key.startsWith('_solstice_')).sort()]);
      const missing = items.filter(i => !before.items.some(b => signature(b) === signature(i)));
      if (missing.length) {
        const response = await nativeFetch(route + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:missing})});
        if (!response.ok) throw Error('UNAVAILABLE_CART');
      }
      // Set exact requested quantities by line key, retaining composition metadata.
      const after = await (await nativeFetch(route + 'cart.js')).json();
      const wanted = new Map();
      for (const item of items) wanted.set(signature(item), (wanted.get(signature(item)) || 0) + item.quantity);
      const updates = Object.fromEntries(after.items.map(i => [i.key, wanted.get(signature(i)) || 0]));
      const updated = await nativeFetch(route + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
      if (!updated.ok) throw Error('UPDATE_FAILED');
      const restored=await updated.json();
      root.SolsticePreorder?.observeCart?.(restored);
      if(root.SolsticePreorder?.prepare)await root.SolsticePreorder.prepare();
      const next = new URL('/checkout', root.location.origin);
      if (params.get('discount')) next.searchParams.set('discount', params.get('discount'));
      next.searchParams.set('locale', params.get('locale') || locale);
      if(root.SolsticePreorder?.checkout)root.SolsticePreorder.checkout(restored,next.toString());
      else root.location.replace(next.toString());
    } catch (_) {
      const box = root.document.createElement('p');
      box.setAttribute('role','alert'); box.style.cssText='padding:16px;text-align:center';
      box.textContent = 'Certains bijoux ne sont plus disponibles dans les quantités demandées. Vérifiez votre panier avant de continuer.';
      (root.document.querySelector('main') || root.document.body).prepend(box);
    }
    return true;
  }
  function state(value) { if (script) script.dataset.recoveryState = value; }
  async function sync() {
    if (busy || recovering) return;
    if (!root.Shopify?.customerPrivacy?.marketingAllowed?.()) { state('waiting-consent'); return; }
    if (!root.klaviyo?.isIdentified) { state('waiting-sdk'); return; }
    busy = true;
    try {
      if (!await root.klaviyo.isIdentified()) { state('waiting-identity'); return; }
      const response = await nativeFetch(route + 'cart.js', {cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json(), data = snapshot(cart, locale, root.location.origin);
      const signature = JSON.stringify(data);
      if (signature === last) return;
      await root.klaviyo.track('Solstice Cart Updated', data);
      last = signature; state('tracked');
    } catch (_) { state('retry-pending'); /* Tracking must never block shopping. */ }
    finally { busy = false; }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 700); }
  root.fetch = async function (...args) {
    const response = await nativeFetch(...args);
    const raw = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    try { const u = new URL(raw, root.location.origin); if (response.ok && u.origin === root.location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname)) schedule(); } catch (_) {}
    return response;
  };
  root.addEventListener('klaviyoForms', e => { if (['submit','stepSubmit'].includes(e.detail?.type)) schedule(); });
  root.document.addEventListener('visitorConsentCollected', schedule);
  root.addEventListener('pageshow', schedule);
  root.document.addEventListener('visibilitychange', schedule);
  setTimeout(sync, 7000);
  // Also catch identification after the popup and cart writes made through XHR.
  const poll = setInterval(() => { if (root.document.visibilityState === 'visible') sync(); }, 15000);
  root.addEventListener('pagehide', () => clearInterval(poll), {once:true});
  if (!root.Shopify?.customerPrivacy && root.Shopify?.loadFeatures) root.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], schedule);
  restore().then(found => { if (!found) schedule(); });
})(typeof window === 'undefined' ? null : window);
